<template>
    <time>{{ showCurrentYear }}</time>
</template>
<script>
    import { MPCVars } from '@/variables.js';

    export default {
        data: function() {
            return {
                showCurrentYear: MPCVars.CURRENT_YEAR
            }
        }
    }
</script>
